import moment from "moment";
import { useCallback, useRef, useState } from "react";

import { useReactToPrint } from "react-to-print";
import { Spinner } from "reactstrap";

export const ButtonPrintKuasaDebet = ({ innerRef, title }) => {
  const [loadingPrint, setLoadingPrint] = useState(false);
  const onBeforeGetContentResolve = useRef(null);

  const reactToPrintContent = useCallback(() => {
    return innerRef.current;
  }, [innerRef]);

  const handleAfterPrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleBeforePrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleOnBeforeGetContent = useCallback(() => {
    setLoadingPrint(true);
    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setLoadingPrint(false);
        resolve();
      }, 2000);
    });
  }, [setLoadingPrint]);

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: title,
    onBeforeGetContent: handleOnBeforeGetContent,
    onBeforePrint: handleBeforePrint,
    onAfterPrint: handleAfterPrint,
    removeAfterPrint: true,
  });

  return (
    <button
      type="submit"
      className="btn btn-item"
      onClick={() => {
        handlePrint();
      }}
    >
      CETAK &nbsp;{loadingPrint ? <Spinner size="sm" className="flex-shrink-0 ms-2" role="status"></Spinner> : ""}
    </button>
  );
};

export const PrintDocKuasaDebet = ({ innerRef, item, companyName, companyValue }) => {
  const handleValidDate = (date) => {
    return moment(date).format("MMM D, YYYY");
  };

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  return item === undefined || item === null ? (
    <></>
  ) : (
    <div
      className="d-none"
      style={{
        overflow: "scroll",
        //backgroundColor: "blue"
      }}
    >
      <div ref={innerRef} className="bg-white" style={{ padding: "40px 80px 40px 80px" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "end",
            marginBottom: "20px",
          }}
        >
          <div>LAMPIRAN XIb</div>
        </div>
        <div
          style={{
            textAlign: "center",
            fontSize: "14px",
            fontWeight: "bold",
          }}
        >
          SURAT KUASA PENDEBETAN DANA
        </div>

        <div style={{ padding: "20px" }}>
          <p>Yang bertanda tangan di bawah ini :</p>

          <table style={{ marginTop: "10px" }}>
            <tbody>
              <tr>
                <td style={{ verticalAlign: "top", width: "20px" }}>I.</td>
                <td style={{ width: "120px" }}>Nama </td>
                <td style={{ width: "20px" }}>:</td>
                <td style={{ fontWeight: "bold" }}>{item.sls_appl?.name ?? "-"}</td>
              </tr>
              <tr>
                <td style={{ verticalAlign: "top" }}></td>
                <td>Tempat/tgl lahir</td>
                <td style={{ width: "20px" }}>:</td>
                <td style={{ fontWeight: "bold" }}>
                  {item.sls_appl?.birth_place ?? ""} , {handleValidDate(item.sls_appl?.birthat) ?? "-"}
                </td>
              </tr>
              <tr>
                <td style={{ verticalAlign: "top" }}></td>
                <td>Pekerjaan</td>
                <td style={{ width: "20px" }}>:</td>
                <td style={{ fontWeight: "bold" }}>{item.sls_appl?.job_desc ?? "-"}</td>
              </tr>
              <tr>
                <td style={{ verticalAlign: "top" }}></td>
                <td>No. KTP/NIK</td>
                <td style={{ width: "20px" }}>:</td>
                <td style={{ fontWeight: "bold" }}>{item.sls_appl?.identity ?? "-"}</td>
              </tr>
              <tr>
                <td style={{ verticalAlign: "top" }}></td>
                <td>Alamat</td>
                <td style={{ width: "20px" }}>:</td>
                <td style={{ fontWeight: "bold" }}>{item.sls_appl?.address ?? "-"}</td>
              </tr>
            </tbody>
          </table>
          <div style={{ marginLeft: "20px" }}>
            yang dalam hal ini bertindak untuk dan atas nama sendiri. Selanjutnya disebut : <span style={{ fontWeight: "bold" }}>PEMBERI KUASA</span>
          </div>

          <table style={{ marginTop: "10px" }}>
            <tbody>
              <tr>
                <td style={{ verticalAlign: "top", width: "20px" }}>II.</td>
                <td>
                  PT BANK TABUNGAN NEGARA (Persero) Tbk, berkedudukan di Jl. Gajah Mada No.1 Jakarta Pusat yang dalam ini di wakili oleh <span style={{ fontWeight: "bold" }}>RACHMAT SUPRIYADI.C.B</span> selaku <span style={{ fontWeight: "bold" }}>BCLU Head Subsidi</span> BTN KC Depok di PT. BANK TABUNGAN NEGARA (Persero) Selanjutnya disebut : <span style={{ fontWeight: "bold" }}>PENERIMA KUASA</span>
                </td>
              </tr>
            </tbody>
          </table>

          <p style={{ marginTop: "20px" }}>
            dengan ini <span style={{ fontWeight: "bold" }}>PEMBERI KUASA</span> memberi kuasa kepada <span style={{ fontWeight: "bold" }}>PENERIMA KUASA</span> untuk melakukan pendebetan pada Nomor Rekening : <span style={{ fontWeight: "bold" }}>00130.0130.000188.0 (an PT. HIKMAH ALAM SENTOSA)</span> atas biaya asuransi, biaya pengikatan agunan, dan biaya lainnya yang timbul atas penghentian KPR Sejahtera yang disebabkan oleh dokumen pernyataan yang saya buat tidak benar dan/atau tidak saya
            penuhi dalam proses pengajuan KPR Sejahtera pada Bank BTN.
          </p>
          <p>Kuasa ini diberikan dengan hak Substitusi, tidak dapat dicabut kembali dan tidak akan berakhir karena sebab -sebab yang tercantum dalam pasal 1813 Kitab Undang-Undang Hukum Perdata atau karena sebab apapun juga.</p>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "start",
              gap: "10px",
            }}
          >
            <div
              style={{
                marginTop: "25px",
                textAlign: "center",
                width: "170px",
              }}
            >
              <div>
                Penerima Kuasa
                <br />
                <div style={{ textAlign: "start" }}>PT Bank Tabungan Negara (Persero), Tbk Kantor Depok</div>
              </div>
            </div>
            <div
              style={{
                marginTop: "25px",
                textAlign: "center",
                width: "170px",
              }}
            >
              <div>
                Bogor, ................................
                <br />
                Pemberi Kuasa
              </div>
              <div
                style={{
                  marginTop: "40px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div style={{ padding: "10px", width: "fit-content", border: "1px solid #000" }}>
                  Materai
                  <br />
                  10.000,-
                </div>
              </div>
            </div>
          </div>
          <div
            style={{
              fontWeight: "bold",
              marginTop: "20px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "start",
              gap: "10px",
            }}
          >
            <div
              style={{
                marginTop: "25px",
                width: "170px",
                textAlign: "center",
              }}
            >
              <div>
                RACHMAT SUPRIYADI.C.B
                <br />
                <span style={{ fontWeight: "normal" }}>BCLU HEAD</span>
              </div>
            </div>
            <div
              style={{
                marginTop: "25px",
                width: "170px",
                textAlign: "center",
              }}
            >
              <div>
                {item.sls_appl?.name ?? "-"} <br />
                <span style={{ fontWeight: "normal" }}>Pemohon</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
